import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useSettingsStore = create(
  persist(
    (set, get) => ({
      theme: 'dark',
      language: 'en',

      setTheme: (theme) => set({ theme }),
      setLanguage: (language) => set({ language }),

      toggleTheme: () =>
        set((s) => ({ theme: s.theme === 'dark' ? 'light' : 'dark' })),

      toggleLanguage: () =>
        set((s) => ({ language: s.language === 'en' ? 'pt-BR' : 'en' })),
    }),
    {
      name: 'settings-store',
    }
  )
);
